import { invalidateAgendaQueries } from "components/marketing-plan/use-agenda-refresh";
import { getQueryClient, trpcOptionsProxy } from "components/rpc/trpc";
import { QueryClient } from "react-query";

export function handleEmailSent(queryClient: QueryClient) {
    queryClient.invalidateQueries(["getConversationFeedForEntity"]);
    invalidateAgendaQueries(trpcOptionsProxy, getQueryClient(), queryClient);
}
